import { useTranslate } from '@tolgee/react';
import React from 'react';

type HeaderTitlesProps = {
  text: string;
  align: string;
};

export const MainHeaderTitles: React.FC<HeaderTitlesProps> = ({
  text,
  align
}) => {
  const { t } = useTranslate();

  return (
    <div className={`d-flex justify-content-${align}`}>
      <h1 className="">{text}</h1>
    </div>
  );
};

export const SubHeaderTitles: React.FC<HeaderTitlesProps> = ({
  text,
  align
}) => {
  const { t } = useTranslate();

  return (
    <div className={`d-flex justify-content-${align}`}>
      <h2 className="">{text}</h2>
    </div>
  );
};

export const SubTitles: React.FC<HeaderTitlesProps> = ({ text, align }) => {
  const { t } = useTranslate();

  return (
    <div className={`d-flex justify-content-${align}`}>
      <h4 className={`text-muted`}>{text}</h4>
    </div>
  );
};
